import { render, staticRenderFns } from "./SetClientConfig.vue?vue&type=template&id=67651d68&"
import script from "./SetClientConfig.vue?vue&type=script&lang=js&"
export * from "./SetClientConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports